import { render, staticRenderFns } from "./DealCollection.vue?vue&type=template&id=5cb237fe&"
import script from "./DealCollection.vue?vue&type=script&lang=js&"
export * from "./DealCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cb237fe')) {
      api.createRecord('5cb237fe', component.options)
    } else {
      api.reload('5cb237fe', component.options)
    }
    module.hot.accept("./DealCollection.vue?vue&type=template&id=5cb237fe&", function () {
      api.rerender('5cb237fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/home/DealCollection.vue"
export default component.exports